export const CURRENT_CONFIG_VERSION = 1

/**
 * Migrates a saved configuration blob from an older version to the current version.
 * Each version bump adds a migration step that applies defaults for new fields.
 * The server stores configVersion alongside the blob so this function can
 * incrementally upgrade any saved config to the latest shape.
 *
 * This is the single point of responsibility for backfilling defaults on older
 * saved configs. We intentionally do NOT merge with DEFAULT_CONFIG on load —
 * that would silently mask missing fields and make it unclear which version
 * introduced them. Instead, when a new field is added to the config schema:
 *   1. Bump CURRENT_CONFIG_VERSION
 *   2. Add a migration step below that sets the new field's default
 *   3. The reducer's LOAD_CONFIG case will receive the fully migrated object
 */
export function migrateConfig (config, fromVersion) {
  const result = { ...config }

  // Future migrations:
  // if (fromVersion < 2) { result.newField = result.newField ?? 'default' }

  return result
}
